// @flow
import { createSelector } from "reselect"

import { passengersCategoryDecoratedSelector } from "booking/services/reservation/selectors/passengersSelectors"
import Price from "common/records/Price"

type MandatorySeatingObject = {|
  price: Price,
  segmentCode: string,
|}

export type MandatorySeatingType = {|
  type: number,
  enabled: boolean,
  data: Array<MandatorySeatingObject>,
|}

const DEFAULT_STATE: MandatorySeatingType = {
  type: 0, // Will be used for general additional services
  enabled: false,
  data: [],
}

const mandatorySeatingReducer = (state: MandatorySeatingType = DEFAULT_STATE, action: any) => {
  switch (action.type) {
    case "SET_MANDATORY_SEATING": {
      const data = action.payload.mandatorySeating.map(pap => ({
        ...pap,
        segmentCode: pap.segment_code,
        price: new Price({
          ...pap.price,
          amount: Number(pap.price.amount),
          base: Number(pap.price.base),
          merchant: Number(pap.price.merchant),
          service: Number(pap.price.service),
          serviceFlat: Number(pap.price.service_flat),
        }),
      }))

      return { ...state, data }
    }
    default:
      return state
  }
}

export default mandatorySeatingReducer

export const mandatorySeatingSelector = (state: any) =>
  state?.reservation?.additionalServices?.mandatorySeating?.data || []

export const shouldRenderMandatorySeating: $FlowFixMe = createSelector(
  mandatorySeatingSelector,
  mandatorySeating => mandatorySeating.length > 0,
)

export const shouldRenderMandatorySeatingForPassenger: $FlowFixMe = createSelector(
  passengersCategoryDecoratedSelector,
  mandatorySeatingSelector,
  (passengers, seating) => (passengerIndex: number) =>
    seating.length === 0 ? false : passengers[passengerIndex].category.value === "child",
)

export const getMandatorySeatingPrice: $FlowFixMe = createSelector(
  mandatorySeatingSelector,
  mandatorySeating => Price.sum(mandatorySeating.map(v => v.price)),
)
